import { displayActiveEmployees } from "./displays/display-active-employees";
import { editEmployee } from "../../infrastructure/repository/employees-repository";
import {
  findFreshEmployees,
  findFreshEmployeesWithFields,
  resetEmployeeCache,
} from "../../infrastructure/employees-cache";

import { displayUploadEmployeesPage } from "./displays/display-upload-employees-page";
import { displayEmployeeDetails } from "./displays/display-employee-details";
import { displayEmployeeFilters } from "./displays/display-employees-filters";
import { hideModal } from "../commons/hide-modal";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate as t } from "../../infrastructure/translate/localization";
import adaptEmployeesForEdition from "../../infrastructure/adapters/adaptemployeesForEdition";
import { showSuccessMessage } from "../commons/show-success-message";

export async function saveEmployee(employee, currentPage = 1) {
  try {
    const companyId = await findCompanyId();
    const { data: empl } = await editEmployee({ companyId, employee });
    resetEmployeeCache();
    findFreshEmployees({ companyId });
    findFreshEmployeesWithFields(companyId);

    addContextLog("info", "saveEmployee", "display-screen", {
      companyId,
      empl,
    });
    if (empl.error) {
      displayEmployeeDetails({
        employeeId: empl.id,
        errors: empl.error,
        currentPage,
      });
    } else if (empl.state !== "uploading") {
      displayActiveEmployees({ currentPage });
      displayEmployeeFilters();
      hideModal();
    } else {
      displayUploadEmployeesPage(currentPage, "upload");
      hideModal();
    }
  } catch (e) {
    logError(e, `Error to saveEmployee ${employee}`);
    showErrorMessage(t("common-messages.basic-error-message"), true);
  }
}

export const saveEmployeesV2 = async ({
  companyId,
  employees,
  benefitPlan,
  taxRegime,
}) => {
  if (employees.length === 1) {
    try {
      await editEmployee({
        companyId,
        employee: adaptEmployeesForEdition({
          employees,
          benefitPlan,
          taxRegime,
        })[0],
      });
      showSuccessMessage(t("success-messages.employee-edited-successfully"));
    } catch (e) {
      logError(
        e,
        `Error to saveEmployeesV2 ${
          adaptEmployeesForEdition({
            employees,
            benefitPlan,
            taxRegime,
          })[0]
        }`
      );
      showErrorMessage(t("common-messages.basic-error-message"), true);
    }
  }
};
